import { useState, useEffect } from 'react';

export interface CompanyInfo {
  address: string; // 주소
  businessRegistrationNumber: string; // 사업자등록증
  mailOrderBusinessNumber: string; // 통신판매업번호
  representativeName: string; // 대표자명
  representativePhoneNumber: string; // 대표자 전화번호
  email: string; // 이메일
  full: string; // 위 정보들을 모두 합친 문자열
}

let cachedCompanyInfo: CompanyInfo | null = null;
let loadingPromise: Promise<CompanyInfo> | null = null;

const fetchCompanyInfo = async (): Promise<CompanyInfo> => {
  if (cachedCompanyInfo) {
    return cachedCompanyInfo;
  }

  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = fetch(`${process.env.NEXT_PUBLIC_LAWCOMPANY_CDN_URL || ''}/company/info.json`)
    .then((res) => {
      if (!res.ok) {
        throw new Error('Failed to fetch company info');
      }
      return res.json();
    })
    .then((data: CompanyInfo) => {
      cachedCompanyInfo = data;
      loadingPromise = null;
      return data;
    })
    .catch((error) => {
      console.error('Failed to load company info:', error);
      loadingPromise = null;
      return {
        address: '',
        full: '',
        businessRegistrationNumber: '',
        email: '',
        mailOrderBusinessNumber: '',
        representativeName: '',
        representativePhoneNumber: '',
      };
    });

  return loadingPromise;
};

const useCompanyInfo = () => {
  const [companyInfo, setCompanyInfo] = useState<CompanyInfo | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let mounted = true;

    const loadInfo = async () => {
      try {
        const data = await fetchCompanyInfo();
        if (mounted) {
          setCompanyInfo(data);
          setIsLoading(false);
        }
      } catch (error) {
        if (mounted) {
          setIsLoading(false);
        }
      }
    };

    if (!cachedCompanyInfo) {
      loadInfo();
    }

    return () => {
      mounted = false;
    };
  }, []);

  return { companyInfo, isLoading };
};

export default useCompanyInfo;
